import { useRef, useCallback, useEffect } from 'react';

export const useAbortableRequest = () => {
  const abortControllersRef = useRef(new Map<string, AbortController>());

  const createController = useCallback((endpointKey: string) => {
    const controllers = abortControllersRef.current;
    
    const existingController = controllers.get(endpointKey);
    if (existingController) {
      existingController.abort();
    }

    const newController = new AbortController();
    controllers.set(endpointKey, newController);
    
    return newController;
  }, []);

  const clearController = useCallback((endpointKey: string) => {
    abortControllersRef.current.delete(endpointKey);
  }, []);

  // Limpa todos os controllers quando o componente desmonta
  useEffect(() => {
    return () => {
      abortControllersRef.current.forEach((controller) => {
        controller.abort();
      });
      abortControllersRef.current.clear();
    };
  }, []);

  return { createController, clearController };
};